import { DataSource, Iframe, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommControlPortal extends Layout {
    iframe1: Iframe;
    panelPortalSection: Panel;
    sourceMCControl: DataSource;
}
